import { createReducer } from './utils';
import {
  TICKETS_LOADING,
  TICKETS_SUCCESS,
  TICKETS_FAILURE,
  CREATE_TICKETS_LOADING,
  CREATE_TICKETS_SUCCESS,
  CREATE_TICKETS_FAILURE,
} from './constants';

const defaultState = {
  errorMessage: '',
  loading: false,
  tickets: [],
  createLoading: false,
  createMessage: 'Ticket Succesfuly Created',
};

// reducer

export const reducer = createReducer(defaultState, {
  [TICKETS_LOADING]: handleTicketsLoading,
  [TICKETS_SUCCESS]: handleTicketsSuccess,
  [TICKETS_FAILURE]: handleTicketsFailure,
  [CREATE_TICKETS_LOADING]: handleCreateTicketsLoading,
  [CREATE_TICKETS_SUCCESS]: handleCreateTicketsSuccess,
  [CREATE_TICKETS_FAILURE]: handleCreateTicketsFailure,
});

function handleTicketsLoading(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function handleTicketsSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    tickets: response.reverse(),
  };
}

function handleTicketsFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    tickets: [],
    errorMessage: error,
  };
}

function handleCreateTicketsLoading(state, action) {
  return {
    ...state,
    createLoading: true,
  };
}

function handleCreateTicketsSuccess(state, { payload: { response } }) {
  return {
    ...state,
    createLoading: false,
    createMessage: response['message'],
  };
}

function handleCreateTicketsFailure(state, { payload: { error } }) {
  return {
    ...state,
    errorMessage: error,
    createLoading: false,
    createMessage: 'Failed Ticket Creation',
  };
}

// actions

export function getTickets() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: TICKETS_LOADING });

    try {
      const response = await dataSource.requestTickets();

      dispatch({ type: TICKETS_SUCCESS, payload: { response } });
    } catch (error) {
      console.log('getTickets error', error);
      dispatch({
        type: TICKETS_FAILURE,
        payload: { error },
      });
    }
  };
}

export function createTickets(description) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: CREATE_TICKETS_LOADING });

    const {
      users: { email },
    } = getState();

    try {
      const response = await dataSource.requestCreateTickets({
        subject: 'Bruno Comment',
        description: description,
        email: email,
      });

      dispatch({ type: CREATE_TICKETS_SUCCESS, payload: { response } });
    } catch (error) {
      console.log('createTickets error', error);
      dispatch({
        type: CREATE_TICKETS_FAILURE,
        payload: { error },
      });
    }
  };
}
